import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';
import ConfigProvider from '../../config-provider';
import { obj } from '../../util';

// 单图片头像
class ImageAvatar extends React.Component {
  static propTypes = {
    prefix: PropTypes.string,
    size: PropTypes.oneOf(['xs', 'small', 'medium', 'large', 'xl']),
    style: PropTypes.object,
    className: PropTypes.string,
    img: PropTypes.string.isRequired,
  }

  static defaultProps = {
    prefix: 'next-',
    size: 'medium',
  }

  render() {
    const { prefix, size, style, className, img, ...others } = this.props;
    return (
      <div
        style={style}
        className={cls({
          [`${prefix}avatar-image`]: true,
          [className]: !!className,
          [`${prefix}avatar-image-${size}`]: true,
        })}
        {...obj.pickAttrs(others)}
      >
        <img src={img} />
      </div>
    );
  }
}

export default ConfigProvider.config(ImageAvatar);
